'use client';

/**
 * 사업자/보호자 활동 로그 React Query 훅
 *
 * 백엔드 명세: BACKEND_HANDOFF_ACTIVITY_LOGS.md
 */

import { useQuery } from '@tanstack/react-query';
import {
  businessActivityLogsApi,
  guardianActivityLogsApi,
  type BusinessActivityLogSearchRequest,
  type GuardianActivityLogSearchRequest,
} from '@/services/api';

// ─── 사업자 ─────────────────────────────────────────────

export function useBusinessOptions() {
  return useQuery({
    queryKey: ['business-activity-logs', 'options'],
    queryFn: () => businessActivityLogsApi.getBusinessOptions(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useBusinessActivityLogs(
  body: BusinessActivityLogSearchRequest,
  refetchKey: number = 0,
) {
  return useQuery({
    queryKey: ['business-activity-logs', body, refetchKey],
    queryFn: () => businessActivityLogsApi.search(body),
    placeholderData: prev => prev,
    staleTime: 0,
    gcTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
}

// ─── 보호자 ─────────────────────────────────────────────

/**
 * 보호자 콤보 옵션
 * - keyword 가 있으면 이름/전화번호 뒷자리 부분 검색 (BE size=50 기본)
 */
export function useGuardianOptions(keyword?: string) {
  return useQuery({
    queryKey: ['guardian-activity-logs', 'options', keyword ?? ''],
    queryFn: () => guardianActivityLogsApi.getGuardianOptions(keyword),
    staleTime: 5 * 60 * 1000,
  });
}

export function useGuardianActivityLogs(
  body: GuardianActivityLogSearchRequest,
  refetchKey: number = 0,
) {
  return useQuery({
    queryKey: ['guardian-activity-logs', body, refetchKey],
    queryFn: () => guardianActivityLogsApi.search(body),
    placeholderData: prev => prev,
    staleTime: 0,
    gcTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
}
